import { Box, TextField, useMediaQuery } from '@mui/material'
import { useContext } from 'react'
import { BREAKPOINT_MIN_MD } from 'Theme/stylesUtil'

import { useDeleteJudgeMutation } from '../../../../Queries/Contests'
import { NotificationContext } from '../../../Notification/context'
import { ContestCreateContext } from '../context'
import { JudgesRoundSelector } from './JudgeProfileComponents/JudgesRoundSelector'

export const JudgeCardInputs = ({ roundNames, handleInput, handleSelect, index }) => {
  const { notification } = useContext(NotificationContext)
  const { watch, contestId } = useContext(ContestCreateContext)
  const isBiggerThanMDScreen = useMediaQuery(BREAKPOINT_MIN_MD)
  const { mutate: deleteJudge } = useDeleteJudgeMutation(contestId)
  const judge = watch(`judges[${index}]`)
  const handleDeleteJudge = (judgeId) => {
    deleteJudge(
      { contestId, judgeId },
      {
        onSuccess: () => {
          notification.success(`You have successfully removed ${judge.login} from contest`)
        },
      },
    )
  }
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        marginLeft: theme.spacing(1),
        gap: theme.spacing(2),
        [theme.breakpoints.down('lg')]: {
          flexDirection: isBiggerThanMDScreen ? 'column' : 'row',
        },
      })}
    >
      <TextField
        value={judge?.role || ''}
        placeholder="Enter title"
        onChange={handleInput}
        sx={{
          minWidth: '100px',
        }}
      />

      <JudgesRoundSelector
        roundNames={roundNames}
        judge={judge}
        onSelect={handleSelect}
        handleDeleteJudge={handleDeleteJudge}
      />
    </Box>
  )
}
